module.exports = __webpack_public_path__ + "img/3.33978970.png";